import React from 'react';
import { Button, Modal } from 'tea-component';
import './index.scss';
export default function LeaveModal(props: any) {
  const {  cancle, confirm, title, message, dblCommonFormatMessage,confirmBtn,cancelBtn,className } = props;
  return (
    <>
      <Modal.Body className={`dbl-leave-modal ${className}`}>
        <div className="body">
          <div className="body-title">{title}</div>
          <div className="body-text">{message}</div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="primary"
          onClick={() => {
            confirm?.();
          }}
        >
          {confirmBtn ? confirmBtn : dblCommonFormatMessage("leave")}
        </Button>
        <Button
          type="weak"
          onClick={() => {
            cancle?.();
          }}
        >
          {cancelBtn? cancelBtn: dblCommonFormatMessage("cancel")}
        </Button>
      </Modal.Footer>
    </>
  );
}
